import { render, staticRenderFns } from "./TargetRulesForm.vue?vue&type=template&id=cec78a72"
import script from "./TargetRulesForm.vue?vue&type=script&lang=ts"
export * from "./TargetRulesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports